module.exports = __webpack_public_path__ + "img/empty.677c79b3.png";